import Vue from 'vue';
import VueRouter from 'vue-router';

// Import your page components
import Home from '@/pages/Home.vue';
import Live from '@/pages/Live.vue';
import NewsAndEvents from '@/pages/NewsAndEvents.vue';
import ContactUs from '@/pages/ContactUs.vue';
import Highlights from '@/pages/Highlights.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', component: Home },
  { path: '/live', component: Live },
  { path: '/newsAndEvents', component: NewsAndEvents },
  { path: '/contactUs', component: ContactUs },
  { path: '/highlights', component: Highlights },
];

const router = new VueRouter({
  mode: 'history', // Enables clean URLs (e.g., /home instead of /#/home)
  routes,
});

export default router;